<template>
  <div class="index">
    <el-button type="primary" size="mini" icon="el-icon-back"
      @click="$router.push('/')">返回</el-button>
    <el-divider content-position="left">云上公司注册小程序通用配置管理</el-divider>
    <div>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-button round @click="$router.push('/ccrmp_city_park')">城市园区管理</el-button>
          <!-- <el-button type="primary" round>主要按钮</el-button>
          <el-button type="success" round>成功按钮</el-button>
          <el-button type="info" round>信息按钮</el-button>
          <el-button type="warning" round>警告按钮</el-button>
          <el-button type="danger" round>危险按钮</el-button> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
}
</script>


<style scoped>
.index {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/miniProCCRMPConfig/Index.vue